import { Directive, Input, ElementRef, AfterContentInit } from '@angular/core';
import { AppState } from './models/interfaces';
import { Store } from '@ngrx/store';



@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements AfterContentInit {

  constructor(private element: ElementRef, private store: Store<AppState>) { }

  public ngAfterContentInit() {
    this.store.select('alert').subscribe(state => {
      if (!state.message) {
        this.setFocus();
      }
    });
    this.setFocus();
  }

  setFocus() {
    //console.log('setting focus', this.element);
    if (this.element.nativeElement.tagName === 'NG-SELECT') {
      const ngSelectComboBox = this.element.nativeElement.querySelector('input[role="combobox"]');
      //console.log(ngSelectComboBox);
      ngSelectComboBox.focus();
    } else {
      this.element.nativeElement.focus();
    }
  }
}
